import React, { useRef, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import logo from 'assets/img/Logo-Humano.png';
import { Formik } from 'formik';
import { isBrowser } from "react-device-detect";
import { NavLink } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import Utils from '../../utils';
import { get, post } from 'services';
import { useHistory } from "react-router";
import Spinner from 'react-bootstrap/Spinner';
import { connect } from 'react-redux';
import { SetUser } from "redux/actions/userActions";
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetLoading } from "redux/actions/loadingActions";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let yup = require('yup');
const Swal = require('sweetalert2');

const marginTopTen = {
  marginBottom: 10
}

const logoStyle = {
  ...marginTopTen,
  marginBottom: 10,
  width: 150,
  marginRight: 30
}


const loadingClases = {
  border: 'solid',
  borderRadius: '50%',
  borderRightColor: 'transparent'
}
const notify = (text) => toast.warn(text, {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
});

const ChangePasswordStepOne = (props) => {
  const history = useHistory();
  const [reCAPTCHA, setReCAPTCHA] = useState('');
  const reRef = useRef();
  const formRef = useRef();
  const schema = yup.object({
    userName: yup.string().email("Debe ser un correo").required('El usuario es requerido'),
  });

  const validateIfUserExist = async () => {
    try {
      props.SetLoading(true);
      const oldValues = formRef.current.values;
      const dto = await get(`Usuario/ValidateIfUserExist?user=${oldValues.userName}`);
      props.SetLoading(false);
      const data = dto.data;
      if (data.usuario && data.usuario.nombre) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    } finally {
      props.SetLoading(false);
    }
  }

  const onSumitted = async (data) => {
    // if (data.newPassword === data.confirmNewPassword) {
    try {
      const exist = await validateIfUserExist();
      if (!exist) {
        notify('El correo que intenta confirmar no se ha registrado');
        return;
      }

      props.SetLoading(true);

      const dto = {
        username: data.userName,
        recaptcha: reCAPTCHA
      };
      var result = await post(`Usuario/ChangePasswordStepOne`, dto);
      if (result && result.data) {
        Swal.fire({
          icon: 'success',
          title: '¡Se ha enviado un mensaje a su correo!',
          text: 'Favor ingresar para validar su identidad'
        });
      } else {
        Swal.fire({
          icon: 'warning',
          title: '¡Atención!',
          text: '¡Favor intente nuevamente!'
        });
      }
    } catch (error) {

    } finally {
      props.SetLoading(false);
    }

    // } else {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: '¡Atención!',
    //     text: '¡Las contraseñas son distintas!'
    //   });
    // }
  }

  return (
    <>
      <ToastContainer />
      {
        props.loading ? (
          <div className={'display-flex flex-direction-row flex-center'}>
            <Spinner style={loadingClases} variant="primary" className={'is-absolute center-spinner-vertically'} animation="border" size="lg" />
          </div>
        ) : <div></div>
      }

      <div className="display-flex flex-center center-vertical flex-direction-column height-100 login-background">
        <div className={'padding-10'}>

          <div className={'display-flex flex-end'}>
            <img style={logoStyle} src={logo} alt="logo" />
          </div>

          <Card className="card-login">
            <Card.Body style={{ width: isBrowser ? '30rem' : '' }} className={'p-30'}>
              <Formik
                innerRef={formRef}
                validationSchema={schema}
                onSubmit={onSumitted}
                initialValues={{
                  userName: '',
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Form.Row>

                      <Form.Group as={Col} md="12" controlId="validationFormik01">
                        <Form.Label> <strong> Correo </strong> </Form.Label>
                        <Form.Control
                          type="email"
                          name="userName"
                          value={values.userName}
                          onChange={handleChange}
                          isValid={touched.userName && !errors.userName}
                          isInvalid={!!errors.userName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.userName}
                        </Form.Control.Feedback>
                      </Form.Group>

                    </Form.Row>
                    
                    <center>
                      <ReCAPTCHA
                        style={{ marginBottom: 10 }}
                        sitekey={process.env.REACT_APP_NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                        onChange={setReCAPTCHA}
                        ref={reRef}
                        hl={'es'}
                      />
                    </center>


                    <div style={{ marginTop: 5 }} className={isBrowser ? 'display-flex space-between' : 'display-flex flex-direction-column center-vertical'}>
                      <div style={marginTopTen} className={'display-flex flex-end-vertical'}>
                        <NavLink
                          to="/SolicitudEmpleo/IniciarSesion"
                          exact
                        >
                          Volver la login
                          </NavLink>
                      </div>
                    </div>
                    

                    <center>
                      <Button style={{width: '50%'}} disabled={reCAPTCHA === ""} variant="dark" type="submit"><strong>  Confirmar correo </strong> </Button>
                    </center>

                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>

        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    loading: state.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
    SetLoading: (value) => dispatch(SetLoading(value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(ChangePasswordStepOne);